import { useNavigate } from 'react-router-dom'
import { LoginCard } from '@/components/ui'
import { customerAuthApi } from '../lib/api'
import { useCustomerAuthStore } from '../stores/auth'

const errorMessages: Record<string, string> = {
  m365_denied: 'Der Microsoft-Login wurde abgebrochen.',
  m365_no_code: 'Microsoft hat keinen Code zurückgeliefert.',
  m365_no_email: 'Dein Microsoft-Konto hat keine E-Mail-Adresse.',
  m365_invalid_client: 'Portal-Konfiguration ist fehlerhaft. Bitte implec kontaktieren.',
  m365_invalid_grant: 'Der Microsoft-Login ist abgelaufen. Bitte erneut versuchen.',
  m365_token_error: 'Microsoft-Login fehlgeschlagen. Bitte erneut versuchen.',
  m365_graph_error: 'Dein Microsoft-Profil konnte nicht geladen werden.',
  m365_error: 'Unbekannter Fehler beim Microsoft-Login.',
  account_pending: 'Dein Zugang wurde angelegt und wartet auf Freischaltung durch implec.',
  customer_not_linked: 'Dein Account ist noch nicht mit einem Kundenkonto verknüpft. Bitte implec kontaktieren.',
  wrong_portal: 'Dieser Account gehört nicht zum Kundenportal.',
}

export function CustomerLoginPage() {
  const navigate = useNavigate()
  const setTokens = useCustomerAuthStore((s) => s.setTokens)

  return (
    <LoginCard
      title="implec Kundenportal"
      subtitle="Anmeldung"
      iconClassName="bg-accent-500"
      m365LoginUrl="/api/auth/customer/m365/login"
      errorMessages={errorMessages}
      footerHint="Du hast noch keinen Zugang? Bitte wende dich an deinen Ansprechpartner bei implec."
      onPasswordLogin={async (email, password) => {
        const res = await customerAuthApi.post<{
          accessToken: string
          refreshToken: string
          user: { id: string; email: string; name: string; customerId: string | null }
        }>('/login', { email, password })
        setTokens({
          accessToken: res.data.accessToken,
          refreshToken: res.data.refreshToken,
          user: res.data.user,
        })
        navigate('/', { replace: true })
      }}
    />
  )
}
